export type LabelMode = "icon" | "icon+name";

export const ZOOM_THRESHOLD_LABB = 16;
export const ZOOM_THRESHOLD_LL = 15;

export const INFOWINDOW_ZOOM_MIN = ZOOM_THRESHOLD_LABB;

export const LABEL_ZOOM_MAX = 20;
export const LABEL_MAX_COUNT = 50;

export const STOP_LOCATIONS_HIDE_BELOW_ZOOM = 16;
export const STOP_LOCATIONS_AUTO_ZOOM = 18;

export const MAP_CONTAINER_STYLE = {
  width: "100%",
  height: "100%",
};

export const CENTER_OF_MAP = {
  lat: 58.25,
  lng: 15.62,
};

export const MD_MEDIA_QUERY = "(min-width: 768px)";
